import client from '../clients';

const PROPERTIES = {
  getProperties({ filters, page, perPage }) {
    const pageParams = page ? `&page=${page}` : ''
    const perPageParams = perPage ? `&per_page=${perPage}` : ''

    return client.get(`/properties`, `${filters}${pageParams}${perPageParams}`);
  },

  getCoordinates(params) {
    return client.get(`/properties/coordinates`, params);
  },

  getProperty(id) {
    return client.get(`/properties/${id}`);
  },
}

export default PROPERTIES;
